<!-- Layout correspondiente a la parte privada. Todas las rutas que lo usen asumen mínimo que el usuario está autenticado -->
<template>
  <div id="private-layout">
    <nav ref="navRef" class="navbar navbar-dark bg-nav sticky-top" :class="{ 'navbar-expand': !menuColapsado, 'menu-colapsado': menuColapsado }"
      :style="envColor ? { backgroundColor: envColor } : {}">
      <div class="container-fluid">
        <a class="navbar-brand" :href="rutaLogoEndesa">
          <img src="@assets/images/logo-endesa-blanco.svg" id="logo-nav" />
        </a>
        <button class="navbar-toggler" type="button" @click="menuAbierto = !menuAbierto"
          aria-controls="navbarSupportedContent" :aria-expanded="menuAbierto" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon text-white"></span>
        </button>
        <div class="collapse navbar-collapse" :class="{ show: menuAbierto && menuColapsado }" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto">
            <li v-if="muestraNavMenuActuaciones" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="actuacionesDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="fa-regular fa-clipboard-list" title="Actuaciones"></i>
                Actuaciones
              </a>
              <ul class="dropdown-menu" aria-labelledby="actuacionesDropdown">
                <li v-if="muestraNavDashboardWo">
                  <I18NRouteLink to="/dashboard-wo" class="dropdown-item">
                    <i class="fa-lg fa-solid fa-bar-chart" title="Dashboard Wo"></i>
                    Dashboard Wo
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavDashboardKpiGmao">
                  <I18NRouteLink to="/dashboard-kpi-gmao" class="dropdown-item">
                    <i class="fa-lg fa-solid fa-chart-mixed" title="KPI GMAO"></i>
                    {{ $t("gmao.dashboardKpi.menu") }}
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavCrearActuacion">
                  <I18NRouteLink to="/nueva-actuacion" class="dropdown-item">
                    <i class="fa-regular fa-file-circle-plus" title="Añadir actuación"></i>
                    Añadir actuación
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavActuaciones">
                  <I18NRouteLink to="/gestion-actuaciones" class="dropdown-item">
                    <i class="fa-regular fa-clipboard-list" title="Actuaciones"></i>
                    Actuaciones
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavWorkOrders">
                  <I18NRouteLink to="/gestion-wo" class="dropdown-item">
                    <i class="fa-regular fa-screwdriver-wrench" title="Work Orders"></i>
                    Work Orders
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisoCampanas" class="dropend dropdown-submenu">
                  <a
                    class="dropdown-item dropdown-toggle d-flex align-items-center justify-content-between"
                    href="#"
                    role="button"
                    :aria-expanded="submenuActivo === 'campanas'"
                    @click.prevent.stop="toggleSubmenu('campanas')"
                  >
                    <span class="d-inline-flex align-items-center gap-2">
                      <i class="fa-regular fa-calendar" title="Campañas"></i>
                      {{ $t("campanas.menu.titulo") }}
                    </span>
                  </a>
                  <ul class="dropdown-menu" :class="{ show: submenuActivo === 'campanas' }">
                    <li>
                      <I18NRouteLink to="/gestion-campanas" class="dropdown-item">
                        <i class="fa-regular fa-calendar" title="Campañas"></i>
                        {{ $t("campanas.menu.campanas") }}
                      </I18NRouteLink>
                    </li>
                    <li v-if="muestraMenuSustitucionesActivos">
                      <I18NRouteLink to="/dashboard-campanas" class="dropdown-item">
                        <i class="fa-lg fa-solid fa-bar-chart" title="Dashboard Campanas"></i>
                        {{ $t("campanas.menu.dashboard") }}
                      </I18NRouteLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li v-if="esGestorRevenueAdmin" class="nav-item">
              <I18NRouteLink to="/revenue-dashboard" class="nav-link">
                <i class="fa-lg fa-solid fa-bar-chart" :title="$t('revenue.dashboard.menu')"></i>
                {{ $t("revenue.dashboard.menu") }}
              </I18NRouteLink>
            </li>

            <li v-if="esGestorRevenueAdmin" class="nav-item">
              <I18NRouteLink to="/revenue-total-devengado" class="nav-link">
                <i class="fa-regular fa-coins" :title="$t('revenue.devengado.menu')"></i>
                {{ $t("revenue.devengado.menu") }}
              </I18NRouteLink>
            </li>

            <!-- Visible para gestores GMAO o usuarios con permiso de ticketing (ej. EchargerSat)-->
            <li v-if="esGestorGmao || muestraNavTicketing" class="nav-item">
              <I18NRouteLink to="/gestion-tickets" class="nav-link">
                <i class="fa-regular fa-triangle-exclamation" title="Tickets"></i>
                Ticketing
              </I18NRouteLink>
            </li>

            <li v-if="esSatSoloActivosMenu" class="nav-item">
              <I18NRouteLink to="/activos" class="nav-link">
                <i class="fa-regular fa-charging-station" :title="$t('activos.menu.activos')"></i>
                {{ $t('activos.menu.activos') }}
              </I18NRouteLink>
            </li>

            <li v-else-if="tienePermisoGestionActivos || tienePermisoGestionOcasAvanzada || muestraNavRecuentoActivos" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="activosDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="fa-regular fa-charging-station" title="Activos"></i>
                {{ $t('activos.menu.titulo') }}
              </a>
              <ul class="dropdown-menu" aria-labelledby="activosDropdown">
                <li v-if="tienePermisoGestionActivos">
                  <I18NRouteLink to="/activos" class="dropdown-item">
                    <i class="fa-regular fa-charging-station" title="Activos"></i>
                    {{ $t('activos.menu.activos') }}
                  </I18NRouteLink>
                </li>
                <li v-if="puedeVerDashboardActivosUsuario">
                  <I18NRouteLink to="/activos/dashboard" class="dropdown-item">
                    <i class="fa-lg fa-solid fa-bar-chart" title="Dashboard activos"></i>
                    {{ $t('activos.menu.dashboard') }}
                  </I18NRouteLink>
                </li>
                <li v-if="muestraMenuSustitucionesActivos">
                  <I18NRouteLink to="/activos/sustituciones" class="dropdown-item">
                    <i class="fa-regular fa-arrows-retweet" title="Sustituciones"></i>
                    {{ $t('activos.menu.sustituciones') }}
                  </I18NRouteLink>
                </li>
                <li v-if="muestraMenuDismissedActivos">
                  <I18NRouteLink to="/activos/dismissed" class="dropdown-item">
                    <i class="fa-regular fa-ban" title="Dismissed"></i>
                    {{ $t('activos.menu.dismissed') }}
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisoGestionOcasAvanzada">
                  <I18NRouteLink to="/oca/ubicaciones" class="dropdown-item">
                    <i class="fa-regular fa-location-dot" title="Ubicaciones"></i>
                    {{ $t("oca.menu.ubicaciones") }}
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisoGestionOcasAvanzada">
                  <I18NRouteLink to="/oca/centros-transformacion" class="dropdown-item">
                    <i class="fa-regular fa-bolt" title="CTs"></i>
                    {{ $t("oca.menu.cts") }}
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavRecuentoActivos">
                  <I18NRouteLink to="/recuento-activos" class="dropdown-item">
                    <i class="fa-regular fa-clipboard-list" title="Recuento de activos"></i>
                    Recuento de activos
                  </I18NRouteLink>
                </li>
              </ul>
            </li>

            <li v-if="muestraNavOcas" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="ocaDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="fa-regular fa-file-certificate" title="OCAs"></i>
                {{ $t("oca.menu.titulo") }}
              </a>
              <ul class="dropdown-menu" aria-labelledby="ocaDropdown">
                <li>
                  <I18NRouteLink to="/oca/ocas" class="dropdown-item">
                    <i class="fa-regular fa-file-certificate" title="OCAs"></i>
                    {{ $t("oca.menu.ocas") }}
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisoGestionOcasAvanzada">
                  <I18NRouteLink to="/oca/dashboard" class="dropdown-item">
                    <i class="fa-lg fa-solid fa-bar-chart" title="Dashboard OCAs"></i>
                    {{ $t("oca.menu.dashboard") }}
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisoGestionOcasAvanzada">
                  <I18NRouteLink to="/oca/seguimiento" class="dropdown-item">
                    <i class="fa-lg fa-solid fa-bar-chart" title="Seguimiento OCAs"></i>
                    {{ $t("oca.menu.seguimiento") }}
                  </I18NRouteLink>
                </li>
              </ul>
            </li>

            <li v-if="muestraNavInspeccionesVisuales" class="nav-item">
              <I18NRouteLink to="/inspecciones-visuales" class="nav-link">
                <i class="fa-regular fa-camera" title="Inspecciones visuales"></i>
                Inspecciones visuales
              </I18NRouteLink>
            </li>

            <li v-if="tienePermisoGestionPrestadores && !esGestorGmao" class="nav-item">
              <I18NRouteLink to="/pds" class="nav-link">
                <i class="fa-regular fa-user-helmet-safety" title="Prestador"></i>
                Prestador
              </I18NRouteLink>
            </li>

            <li v-if="muestraNavEquipoMedida && !esGestorGmao" class="nav-item">
              <I18NRouteLink to="/equipo-medida" class="nav-link">
                <i class="fa-regular fa-gauge-high" title="Equipos de medida"></i>
                Equipos de medida
              </I18NRouteLink>
            </li>

            <li v-if="mostrarEnlaceInformesVariable" class="nav-item">
              <I18NRouteLink to="/informes" class="nav-link">
                <i class="fa-regular fa-chart-bar" title="Informe variable"></i>
                Informe variable
              </I18NRouteLink>
            </li>
            <li v-if="mostrarEnlaceInformesFijo" class="nav-item">
              <I18NRouteLink to="/informes-fijo" class="nav-link">
                <i class="fa-regular fa-file-invoice-dollar" title="Canon fijo"></i>
                Canon fijo
              </I18NRouteLink>
            </li>

            <li v-if="tienePermisoGestionPartners" class="nav-item">
              <I18NRouteLink to="/partners" class="nav-link">
                <i class="fa-regular fa-handshake"
                  title="{{tienePermisosSelfRevenue?'Mis empresas':'Partners'}}"></i>
                {{ tienePermisosSelfRevenue ? 'Mis empresas' : 'Partners' }}
              </I18NRouteLink>
            </li>

            <li v-if="muestraNavMaestroPagos || muestraNavMaestroPagosB2c || muestraNavMaestroPagosInspeccionesVisuales" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="alarmeroDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="fa-lg fa-solid fa-file-spreadsheet" title="Alarmero"></i>
                Maestro de pagos
              </a>
              <ul class="dropdown-menu" aria-labelledby="alarmeroDropdown">
                <li v-if="muestraNavMaestroPagosVistaGeneral" class="nav-item">
                  <I18NRouteLink to="/maestro-de-pagos" class="nav-link">
                    <i class="fa-lg fa-solid fa-file-spreadsheet" title="Maestro de pagos"></i>
                    Vista general
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavMaestroPagos" class="nav-item">
                  <I18NRouteLink to="/maestro-de-pagos-prestador" class="nav-link">
                    <i class="fa-lg fa-solid fa-file-spreadsheet" title="Maestro de pagos prestador"></i>
                    Vista prestador
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisoEditarAllWo" class="nav-item">
                  <I18NRouteLink to="/maestro-de-pagos-graficos" class="nav-link">
                    <i class="fa-lg fa-solid fa-bar-chart" title="Gráficos y estadísticas"></i>
                    Gráficos
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavMaestroPagosB2c" class="nav-item">
                  <I18NRouteLink to="/maestro-de-pagos-b2c" class="nav-link">
                    <i class="fa-lg fa-solid fa-file-spreadsheet" title="B2C"></i>
                    {{ $t("maestro_pagos.b2c.menu") }}
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavMaestroPagosInspeccionesVisuales" class="nav-item">
                  <I18NRouteLink to="/maestro-de-pagos-iv" class="nav-link">
                    <i class="fa-lg fa-solid fa-file-spreadsheet" :title="$t('maestro_pagos.iv.titulo')"></i>
                    {{ $t("maestro_pagos.iv.titulo") }}
                  </I18NRouteLink>
                </li>
              </ul>
            </li>
           

            <li v-if="esGestorGmao" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="alarmeroDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="fa-regular fa-circle-exclamation" title="Alarmero"></i>
                Alarmero
              </a>
              <ul class="dropdown-menu" aria-labelledby="alarmeroDropdown">
                <li v-if="esGestorGmao">
                  <I18NRouteLink to="/clientes" class="dropdown-item">
                    <i class="fa-regular fa-charging-station" title="Clientes y cargadores"></i>
                    Clientes y cargadores
                  </I18NRouteLink>
                </li>
                <li v-if="esGestorGmao">
                  <I18NRouteLink to="/suscripciones" class="dropdown-item">
                    <i class="fa-regular fa-gear" title="Suscripciones"></i>
                    Suscripciones
                  </I18NRouteLink>
                </li>
              </ul>
            </li>

            <li v-if="esGestorGmao" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="alarmeroDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="fa-regular fa-gear" title="Configuración"></i>
                Configuración
              </a>
              <ul class="dropdown-menu" aria-labelledby="alarmeroDropdown">
                <li v-if="tienePermisoGestionPrestadores">
                  <I18NRouteLink to="/pds" class="dropdown-item">
                    <i class="fa-regular fa-user-helmet-safety" title="Prestador"></i>
                    Prestador
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisoGestionPrestadores">
                  <I18NRouteLink to="/buscador-prestadores" class="dropdown-item">
                    <i class="fa-regular fa-magnifying-glass-location" title="Buscador de prestadores"></i>
                    Buscador de prestadores
                  </I18NRouteLink>
                </li>
                <li v-if="muestraNavEquipoMedida">
                  <I18NRouteLink to="/equipo-medida" class="dropdown-item">
                    <i class="fa-regular fa-gauge-high" title="Equipos de medida"></i>
                    Equipos de medida
                  </I18NRouteLink>
                </li>
                <li v-if="tienePermisosUsuarios">
                  <I18NRouteLink to="/usuarios" class="dropdown-item">
                    <i class="fa-regular fa-users" title="Usuarios"></i>
                    Usuarios
                  </I18NRouteLink>
                </li>
                <li class="dropend dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle d-flex align-items-center justify-content-between" href="#"
                    role="button" :aria-expanded="submenuActivo === 'interoperabilidad'"
                    @click.prevent.stop="toggleSubmenu('interoperabilidad')">
                    <span class="d-inline-flex align-items-center gap-2">
                      <i class="fa-regular fa-arrows-repeat" aria-hidden="true"></i>
                      {{ $t("interoperabilidad.titulo") }}
                    </span>
                  </a>
                  <ul class="dropdown-menu" :class="{ show: submenuActivo === 'interoperabilidad' }">
                    <li><I18NRouteLink to="/configuracion-general/interoperabilidad" class="dropdown-item">{{ $t("interoperabilidad.pestanas.msp") }}</I18NRouteLink></li>
                    <li><I18NRouteLink to="/configuracion-general/interoperabilidad/tarifas" class="dropdown-item">{{ $t("interoperabilidad.pestanas.tarifa") }}</I18NRouteLink></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li v-if="puedeGestionarInteroperabilidad && !esGestorGmao" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="interoperabilidadDropdown" role="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa-regular fa-arrows-repeat" aria-hidden="true"></i>
                {{ $t("interoperabilidad.titulo") }}
              </a>
              <ul class="dropdown-menu" aria-labelledby="interoperabilidadDropdown">
                <li><I18NRouteLink to="/configuracion-general/interoperabilidad" class="dropdown-item">{{ $t("interoperabilidad.pestanas.msp") }}</I18NRouteLink></li>
                <li><I18NRouteLink to="/configuracion-general/interoperabilidad/tarifas" class="dropdown-item">{{ $t("interoperabilidad.pestanas.tarifa") }}</I18NRouteLink></li>
              </ul>
            </li>

            <li v-if="esAdminQuely" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="adminQuelyDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="fa-regular fa-screwdriver-wrench" title="Admin"></i>
                Admin
              </a>
              <ul class="dropdown-menu" aria-labelledby="adminQuelyDropdown">
                <li>
                  <I18NRouteLink to="/admin-tareas-programadas" class="dropdown-item">
                    <i class="fa-regular fa-stopwatch" title="Tareas programadas"></i>
                    Tareas programadas
                  </I18NRouteLink>
                </li>
                <li>
                  <I18NRouteLink to="/admin-quely" class="dropdown-item">
                    <i class="fa-regular fa-gear" title="Admin Quely"></i>
                    Admin Quely
                  </I18NRouteLink>
                </li>
              </ul>
            </li>

            <li v-if="tienePermisosUsuarios && !esGestorGmao" class="nav-item">
              <I18NRouteLink to="/usuarios" class="nav-link">
                <i class="fa-regular fa-users" title="Usuarios"></i>
                Usuarios
              </I18NRouteLink>
            </li>
          </ul>
          <div class="controles-movil gap-2 align-items-center justify-content-between" :class="menuColapsado ? 'd-flex' : 'd-none'">
            <button
              type="button"
              class="btn-notificaciones-nav btn btn-link text-white text-decoration-none p-2"
              :aria-label="$t('notificaciones.abrir_panel')"
              @click="toggleNotificaciones"
            >
              <span class="position-relative d-inline-flex">
                <i class="fa-regular fa-bell fa-lg" aria-hidden="true"></i>
                <span
                  v-if="numNotificacionesSinLeer > 0"
                  class="notificaciones-badge position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                >
                  {{ numNotificacionesSinLeer > 99 ? "99+" : numNotificacionesSinLeer }}
                </span>
              </span>
            </button>
            <div class="align-content-center text-white">
              {{ auth.userInfo?.username }}

            </div>
           
            <I18NRouteLink
              v-if="puedeVerPreferencias"
              to="/preferencias"
              class="btn btn-link text-white text-decoration-none p-2"
              :title="$t('preferencias.menu')"
            >
              <i class="fa-regular fa-sliders" aria-hidden="true"></i>
            </I18NRouteLink>
            <DxButton @click="logout" type="default">{{
              $t("shared.ui.buttons.logout")
            }}</DxButton>
          </div>
          <div class="controles-escritorio gap-3 align-items-center" :class="menuColapsado ? 'd-none' : 'd-flex'">
            <button
              type="button"
              class="btn-notificaciones-nav btn btn-link text-white text-decoration-none px-2 py-0 d-flex align-items-center"
              :aria-label="$t('notificaciones.abrir_panel')"
              @click="toggleNotificaciones"
            >
              <span class="position-relative d-inline-flex">
                <i class="fa-regular fa-bell fa-lg" aria-hidden="true"></i>
                <span
                  v-if="numNotificacionesSinLeer > 0"
                  class="notificaciones-badge position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                >
                  {{ numNotificacionesSinLeer > 99 ? "99+" : numNotificacionesSinLeer }}
                </span>
              </span>
            </button>
            <div class="dropdown-usuario">
              <button class="user-circle border-0 p-0" type="button" id="userDropdown" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{ userInitials }}
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li v-if="puedeVerPreferencias">
                  <I18NRouteLink class="dropdown-item" to="/preferencias">
                    <i class="fa-regular fa-sliders"></i> {{ $t("preferencias.menu") }}
                  </I18NRouteLink>
                </li>
                <li v-if="puedeVerPreferencias"><hr class="dropdown-divider"></li>
                <li>
                  <button class="dropdown-item" @click="logout"><i class="fa-regular fa-sign-out"></i> {{
                    $t('shared.ui.buttons.logout') }}</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <NotificacionesPanel
      :is-visible="notificacionesVisible"
      @close-notificaciones="toggleNotificaciones"
    />
    <div class="private-body" :class="{
      'echarger': esUsuarioLoveCharger,
      'rsync': esUsuarioRsSync
    }">
      <main>
        <slot></slot>
      </main>
    </div>
    <footer class="text-white py-2 small">
      <div class="container-fluid">
        <div v-if="esGestorGmao" class="row">
          <div class="col text-end">
            Última importación:
            <strong>{{ formattedUltimaImportacion }}</strong> | Anterior:
            <strong>{{ formattedAnteriorImportacion }}</strong>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script setup lang="ts">
import { useAuthentication, ExtendedUserInfo } from "@services/auth";
import { DxButton } from "devextreme-vue/button";
import I18NRouteLink from "@components/i18n/I18NRouteLink.vue";
import NotificacionesPanel from "@/components/notificaciones/NotificacionesPanel.vue";
import type { FechasImportacion } from "@api/api";
import { useApi } from "@api/integration";
import { onMounted, onBeforeUnmount, ref, computed, provide, watch } from "vue";
import { useRoute } from "vue-router";
import { useAuthorization, PermissionsApp } from "@services/auth/authorization";
import { useVersionCheck } from "@services/version-check-service";
import {
  isGestorRevenueAdmin,
  REVENUE_DASHBOARD_PATH,
} from "@/.shared/helpers/revenue-auth-helper";
import { esSatSoloActivos, puedeVerDashboardActivos } from "@helpers/activos-permissions-helper";
import { tienePermisoGestionOcasCatalogo } from "@/components/oca/shared/oca-auth";
import {
  puedeVerNavActuaciones,
  puedeVerNavCrearActuacion,
  puedeVerCampanas,
  puedeVerNavDashboardWo,
  puedeVerNavDashboardKpiGmao,
  puedeVerNavEquipoMedida,
  puedeVerNavInspeccionesVisuales,
  puedeVerNavMaestroPagos,
  puedeVerNavMaestroPagosB2c,
  puedeVerNavMaestroPagosInspeccionesVisuales,
  puedeVerNavOcas,
  puedeVerNavTicketing,
} from "@/helpers/pds-modulos-helper";

const autho = useAuthorization();
const auth = useAuthentication();
const api = useApi();
const navRef = ref<HTMLElement | null>(null);
const menuColapsado = ref(true);
const menuAbierto = ref(false);
let observadorNav: ResizeObserver | undefined;
let observadorContenido: MutationObserver | undefined;
let frameMedicion = 0;
let componenteActivo = false;

// La copia permite medir la disposición horizontal incluso con el menú cerrado.
function actualizarMenu() {
  const nav = navRef.value;
  const contenedor = nav?.querySelector<HTMLElement>(":scope > .container-fluid");
  const marca = contenedor?.querySelector<HTMLElement>(":scope > .navbar-brand");
  const panel = contenedor?.querySelector<HTMLElement>(":scope > .navbar-collapse");
  const lista = panel?.querySelector<HTMLElement>(":scope > .navbar-nav");
  const controles = panel?.querySelector<HTMLElement>(":scope > .controles-escritorio");
  if (!nav?.isConnected || !contenedor || !marca || !panel || !lista || !controles) return;

  const copia = nav.cloneNode(false) as HTMLElement;
  const contenedorCopia = contenedor.cloneNode(false) as HTMLElement;
  const panelCopia = panel.cloneNode(false) as HTMLElement;
  const listaCopia = lista.cloneNode(false) as HTMLElement;
  const controlesCopia = controles.cloneNode(true) as HTMLElement;
  for (const opcion of Array.from(lista.children)) {
    const opcionCopia = opcion.cloneNode(false) as HTMLElement;
    const enlace = opcion.firstElementChild;
    if (enlace) opcionCopia.appendChild(enlace.cloneNode(true));
    listaCopia.appendChild(opcionCopia);
  }
  controlesCopia.querySelectorAll(".dropdown-menu").forEach(elemento => elemento.remove());
  controlesCopia.classList.replace("d-none", "d-flex");
  panelCopia.classList.remove("show", "collapsing");
  panelCopia.classList.add("collapse");
  panelCopia.append(listaCopia, controlesCopia);
  contenedorCopia.append(marca.cloneNode(true), panelCopia);
  copia.appendChild(contenedorCopia);
  copia.classList.add("navbar-expand");
  copia.classList.remove("menu-colapsado");
  copia.setAttribute("aria-hidden", "true");
  copia.setAttribute("inert", "");
  copia.removeAttribute("id");
  copia.querySelectorAll("[id]").forEach(elemento => elemento.removeAttribute("id"));
  Object.assign(copia.style, { position: "fixed", visibility: "hidden", width: "max-content", maxWidth: "none", top: "0", left: "0", zIndex: "-1" });
  nav.parentElement?.appendChild(copia);
  const anchoNecesario = copia.getBoundingClientRect().width;
  copia.remove();
  const anchoDisponible = Math.min(nav.clientWidth, document.documentElement.clientWidth);
  const debeColapsar = anchoDisponible < anchoNecesario + (menuColapsado.value ? 24 : 0);
  if (menuColapsado.value && !debeColapsar) menuAbierto.value = false;
  menuColapsado.value = debeColapsar;
}

function programarMedicion() {
  if (!componenteActivo) return;
  cancelAnimationFrame(frameMedicion);
  frameMedicion = requestAnimationFrame(actualizarMenu);
}

const notificacionesVisible = ref(false);
const numNotificacionesSinLeer = ref(0);
provide("numNotificacionesSinLeer", numNotificacionesSinLeer);

const formattedUltimaImportacion = ref<string | null>(null);
const formattedAnteriorImportacion = ref<string | null>(null);
const userInitials = computed(() => {
  const username = auth.userInfo?.username || "";
  return username.substring(0, 2).toUpperCase();
});

const esUsuarioLoveCharger = autho.hasPermission(PermissionsApp.UserLoveCharger);
const esUsuarioRsSync = autho.hasPermission(PermissionsApp.UserRssync);
const esGestorGmao = autho.hasPermission(PermissionsApp.GestionAvanzadaActuacionesAll);
const puedeVerPreferencias = esGestorGmao;
const puedeGestionarInteroperabilidad = autho.hasPermission(PermissionsApp.EditAllTransacciones);
const esAdminQuely = autho.hasPermission(PermissionsApp.AdminQuely);

const tienePermisosUsuarios = autho.hasPermission(PermissionsApp.EditAllUsuariosGmao) || autho.hasPermission(PermissionsApp.EditSelfUsuariosPrestadorGmao) || autho.hasPermission(PermissionsApp.EditAllUsuariosRevenue);

const tienePermisoGestionPrestadores = autho.hasPermission(PermissionsApp.EditPrestadores);

const esAdminRevenue = autho.hasPermission(PermissionsApp.EditAllTransacciones);
const esGestorRevenueAdmin = isGestorRevenueAdmin(autho);
/** Logo Endesa: gestor revenue → dashboard; resto → inicio habitual. */
const rutaLogoEndesa = computed(() =>
  esGestorRevenueAdmin ? REVENUE_DASHBOARD_PATH : "/"
);
const tienePermisoGestionInformesVariable = esAdminRevenue || autho.hasPermission(PermissionsApp.EditSelfTransacciones) || autho.hasPermission(PermissionsApp.ReadSelfTransacciones);
const tienePermisoGestionInformesFijo = esAdminRevenue || autho.hasPermission(PermissionsApp.EditSelfTransacciones) || autho.hasPermission(PermissionsApp.ReadSelfTransacciones);

const userSession = computed(() => auth.userInfo as ExtendedUserInfo | null);

const muestraNavDashboardWo = computed(() =>
  puedeVerNavDashboardWo(autho, userSession.value),
);
const muestraNavDashboardKpiGmao = computed(() => puedeVerNavDashboardKpiGmao(autho));
const tienePermisoCampanas = computed(() =>
  puedeVerCampanas(autho, userSession.value),
);
const muestraNavActuaciones = computed(() =>
  puedeVerNavActuaciones(autho, userSession.value),
);
const muestraNavCrearActuacion = computed(() =>
  puedeVerNavCrearActuacion(autho, userSession.value),
);
const muestraNavMaestroPagos = computed(() =>
  puedeVerNavMaestroPagos(autho, userSession.value),
);
const muestraNavMaestroPagosB2c = computed(() =>
  puedeVerNavMaestroPagosB2c(autho, userSession.value),
);
const muestraNavMaestroPagosInspeccionesVisuales = computed(() =>
  puedeVerNavMaestroPagosInspeccionesVisuales(autho, userSession.value),
);
const muestraNavMaestroPagosVistaGeneral = computed(() =>
  tienePermisoEditarAllWo || tienePermisoEditarSelfWo,
);
const muestraNavOcas = computed(() =>
  puedeVerNavOcas(autho, userSession.value),
);
const muestraNavInspeccionesVisuales = computed(() =>
  puedeVerNavInspeccionesVisuales(autho, userSession.value),
);
const muestraNavTicketing = computed(() =>
  puedeVerNavTicketing(autho, userSession.value),
);
const muestraNavEquipoMedida = computed(() =>
  puedeVerNavEquipoMedida(autho, userSession.value),
);

const mostrarEnlaceInformesVariable = computed(
  () => tienePermisoGestionInformesVariable && (userSession.value?.tieneInformesVariable === true)
);
const mostrarEnlaceInformesFijo = computed(
  () => tienePermisoGestionInformesFijo && (userSession.value?.tieneInformesFijo === true)
);
const tienePermisoGestionPartners = autho.hasPermission(PermissionsApp.EditSelfPartners) || autho.hasPermission(PermissionsApp.EditAllPartners);
const tienePermisoGestionOcasAvanzada = tienePermisoGestionOcasCatalogo(autho);
const tienePermisoGestionActivos = autho.hasPermission(PermissionsApp.EditAllActivosRevenue) || autho.hasPermission(PermissionsApp.EditSelfActivosRevenue) || autho.hasPermission(PermissionsApp.EditAllActivosGmao) || autho.hasPermission(PermissionsApp.EditSelfActivosGmao) || autho.hasPermission(PermissionsApp.GestionTicketingAll);
const esSatSoloActivosMenu = computed(() => esSatSoloActivos(autho));

const tienePermisosSelfRevenue = autho.hasPermission(PermissionsApp.EditSelfActivosRevenue) || autho.hasPermission(PermissionsApp.EditSelfPartners); //Para los partner y BD

const tienePermisoEditarAllWo = autho.hasPermission(PermissionsApp.EditAllWo);
const tienePermisoEditarSelfWo = autho.hasPermission(PermissionsApp.EditSelfWo);
const tienePermisoWorkOrdersRevenueActivos =
  autho.hasPermission(PermissionsApp.EditAllActivosRevenue) || autho.hasPermission(PermissionsApp.EditSelfActivosRevenue);
const necesitaComprobarPartnerPrivadoRevenueWo =
  autho.hasPermission(PermissionsApp.EditSelfActivosRevenue) &&
  !autho.hasPermission(PermissionsApp.EditAllActivosRevenue);
const puedeVerWoSustitucionesRevenuePartnerPrivado = ref(!necesitaComprobarPartnerPrivadoRevenueWo);

const muestraNavWorkOrders = computed(
  () =>
    muestraNavDashboardWo.value ||
    (tienePermisoWorkOrdersRevenueActivos && puedeVerWoSustitucionesRevenuePartnerPrivado.value),
);
const muestraNavMenuActuaciones = computed(
  () =>
    muestraNavDashboardWo.value ||
    muestraNavDashboardKpiGmao.value ||
    muestraNavCrearActuacion.value ||
    muestraNavActuaciones.value ||
    muestraNavWorkOrders.value ||
    tienePermisoCampanas.value,
);

const esGmaoActivosMenu =
  autho.hasPermission(PermissionsApp.EditAllActivosGmao) || autho.hasPermission(PermissionsApp.EditSelfActivosGmao);
const muestraMenuSustitucionesActivos = computed(
  () =>
    esGmaoActivosMenu ||
    autho.hasPermission(PermissionsApp.EditAllActivosRevenue) ||
    (autho.hasPermission(PermissionsApp.EditSelfActivosRevenue) && puedeVerWoSustitucionesRevenuePartnerPrivado.value),
);
const muestraMenuDismissedActivos = autho.hasPermission(PermissionsApp.EditAllActivosGmao);
const puedeVerDashboardActivosUsuario = puedeVerDashboardActivos(autho);
const muestraNavRecuentoActivos = esGestorGmao && tienePermisoEditarAllWo;

useVersionCheck();

function logout() {
  auth.logout(import.meta.env.VITE_BASE_URL);
}

function toggleNotificaciones() {
  notificacionesVisible.value = !notificacionesVisible.value;
}

async function cargarPuedeVerWoSustitucionesRevenuePrivado(): Promise<void> {
  if (!necesitaComprobarPartnerPrivadoRevenueWo) {
    puedeVerWoSustitucionesRevenuePartnerPrivado.value = true;
    return;
  }
  try {
    const puede = await api.callStandardApi("getRevenueSelfPuedeVerWoSustituciones", { showLoading: false });
    puedeVerWoSustitucionesRevenuePartnerPrivado.value = Boolean(puede);
  } catch {
    puedeVerWoSustitucionesRevenuePartnerPrivado.value = false;
  }
}

watch(
  () => auth.userInfo?.idUsuario ?? auth.userInfo?.username ?? null,
  () => {
    void cargarPuedeVerWoSustitucionesRevenuePrivado();
  },
);

const route = useRoute();
const submenuActivo = ref<string | null>(null);

function toggleSubmenu(id: string) {
  submenuActivo.value = submenuActivo.value === id ? null : id;
}

watch(
  () => route.fullPath,
  () => {
    submenuActivo.value = null;
  }
);

onMounted(async () => {
  componenteActivo = true;
  if (navRef.value) {
    observadorNav = new ResizeObserver(programarMedicion);
    observadorNav.observe(navRef.value);
    observadorContenido = new MutationObserver(programarMedicion);
    const lista = navRef.value.querySelector(".navbar-nav");
    if (lista) observadorContenido.observe(lista, { childList: true, subtree: true, characterData: true });
    document.fonts.ready.then(programarMedicion);
    document.fonts.addEventListener("loadingdone", programarMedicion);
    window.addEventListener("resize", programarMedicion);
    programarMedicion();
  }
  const navElement = document.getElementById("navbarSupportedContent");
  navElement?.addEventListener("hidden.bs.dropdown", () => {
    submenuActivo.value = null;
  });

  await cargarPuedeVerWoSustitucionesRevenuePrivado();

  if (esGestorGmao) {
    var result = (await api.callStandardApi("fechasImportacion", {
      showLoading: true,
    })) as FechasImportacion;
    if (result) {
      formattedUltimaImportacion.value = result.UltimaImportacion;
      formattedAnteriorImportacion.value = result.AnteriorImportacion;
    }
  }

});


onBeforeUnmount(() => {
  componenteActivo = false;
  observadorNav?.disconnect();
  observadorContenido?.disconnect();
  document.fonts.removeEventListener("loadingdone", programarMedicion);
  window.removeEventListener("resize", programarMedicion);
  cancelAnimationFrame(frameMedicion);
});

const prefix = import.meta.env.VITE_TITLE_PREFIX;
const envColor = computed(() => {
  switch (prefix) {
    case "DEV":
      return "#237f47";
    case "PRE":
      return "#461e7b";
    default:
      return null;
  }
});

</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/_themevars.scss";
@import "@/styles/figma.scss";

#private-layout {
  display: grid;
  grid-template-rows: 64px 1fr 40px;
  height: 100vh;
  min-height: 0;
}

#private-layout>nav {
  grid-row: 1;
  min-height: 64px;
  max-height: 64px;
  position: relative;
  z-index: 10;
}

.private-body {
  grid-row: 2;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  /*
  &.echarger {
    background-image: url('@assets/images/echarger-opacity.svg');
    background-size: 20vw;
    background-repeat: no-repeat;
    background-position: calc(100% - 30px) calc(100% - 30px);
  }
*/
  &.rsync {
    background-image: url('@assets/images/rssync-opacity.svg');
    background-size: 15vw;
    background-repeat: no-repeat;
    background-position: calc(100% - 30px) calc(100% - 30px);
  }
}

.private-body main {
  flex: 1 1 0%;
  min-height: 0;
  overflow: auto;

  display: flex;
  padding: var(--spacing-md);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-md, 16px);
}

#private-layout>footer {
  grid-row: 3;
  min-height: 40px;
  max-height: 40px;
  position: relative;
  z-index: 10;
  border-top: 5px solid var(--border-primary-default, #D3135A);
  background: var(--background-normal-dark, #0E141A);
}

#logo-nav {
  max-height: 2rem;
}

.bg-nav {
  background: var(--background-secondary-default, #1863ED);
  box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.10);
}


.navbar-brand {
  margin-right: var(--spacing-xl);
}

.dx-button-mode-outlined {
  color: #ffffff;
}

.dx-button-mode-outlined.dx-state-hover {
  color: $base-accent;
}

.navbar-nav {
  display: flex;
  padding: var(--button-vertical-padding, 6px) var(--button-horizontal-padding, 12px);
  align-items: center;
  gap: 12px;
}

.navbar-nav .nav-link {
  padding: var(--button-vertical-padding, 6px) var(--button-horizontal-padding, 12px);
  color: var(--text-default-inverse, #FFF);
  font-size: var(--font-size-body-md, 14px);
  font-weight: 400;
  line-height: var(--line-height-body-md, 24px);
  /* 171.429% */
  display: flex;
  gap: var(--spacing-xs, 8px);
  align-items: center;


  &:hover,
  &:focus,
  &.show,
  &[aria-expanded="true"] {
    color: var(--text-primary-default, #D3135A);
    border-radius: var(--button-radius, 5px);
    background: var(--background-normal-hover, #F0F0F0);

    i {
      color: var(--text-secondary-default);
    }
  }
}

.navbar-nav .dropdown-menu {
  border-radius: var(--border-radius-none);
  top: 47px;
  background: var(--background-secondary-dark, #1146A8);
  padding: var(--spacing-xs, 8px);
  flex-direction: column;
  align-items: stretch;

  &.show {
    display: flex;
  }

  .dropdown-item {
    color: var(--text-default-inverse, #FFF);
    font-size: var(--font-size-body-md, 14px);
    font-weight: 400;
    line-height: var(--line-height-body-md, 24px);
    display: flex;
    padding: var(--button-vertical-padding, 6px) var(--button-horizontal-padding, 12px);
    align-items: center;
    gap: 12px;
    border-radius: var(--button-radius, 5px);

    &:hover,
    &:focus {
      color: var(--text-primary-default, #D3135A);
      background: var(--background-normal-hover, #F0F0F0);
      padding: var(--button-vertical-padding, 6px) var(--button-horizontal-padding, 12px);

      i {
        color: var(--text-secondary-default);
      }
    }
  }

  .dropdown-submenu {
    position: relative;

    > .dropdown-item.dropdown-toggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      outline: 0;
      box-shadow: none;

      &::after {
        margin-left: auto !important;
      }
    }

    > .dropdown-item.dropdown-toggle[aria-expanded="true"] {
      color: var(--text-primary-default, #D3135A);
      background: var(--background-normal-hover, #F0F0F0);

      i {
        color: var(--text-secondary-default);
      }
    }

    > .dropdown-menu {
      top: calc(-1px - var(--spacing-xs));
      left: calc(100% + var(--spacing-xs));
      box-shadow: none;
      margin-top: 0;
      margin-left: 0;
      
    }
  }
}

.dropdown-usuario .dropdown-menu {
  border-radius: var(--border-radius-none);
  top: 62px;
  background: var(--background-secondary-dark, #1146A8);
  padding: var(--spacing-2xs);
  align-items: stretch;

  .dropdown-item {
    color: var(--text-default-inverse, #FFF);
    font-size: var(--font-size-body-md, 14px);
    font-weight: 400;
    line-height: var(--line-height-body-md, 24px);
    display: flex;
    padding: var(--button-vertical-padding, 6px) var(--button-horizontal-padding, 12px);
    align-items: center;
    gap: 12px;
    border-radius: var(--button-radius, 5px);

    &:hover,
    &:focus {
      color: var(--text-primary-default, #D3135A);
      background: var(--background-normal-hover, #F0F0F0);
      padding: var(--button-vertical-padding, 6px) var(--button-horizontal-padding, 12px);

      i {
        color: var(--text-secondary-default);
      }
    }


  }
}

.menu-colapsado > .container-fluid {
  background: inherit;
}

.menu-colapsado .navbar-collapse {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  background: inherit;
  padding: var(--spacing-sm, 12px);
}

.menu-colapsado .navbar-nav {
  align-items: stretch;
}

.menu-colapsado .navbar-nav .dropdown-submenu > .dropdown-menu {
  position: static;
  float: none;
  margin-left: var(--spacing-sm, 12px);
}

@media (max-width: 991.98px) {
  #private-layout {
    display: block;
    height: auto;
  }

  #private-layout>nav {
    min-height: unset;
    max-height: unset;
    position: relative;
  }

  #private-layout>footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 10;
  }

  .private-body {
    display: block;
    min-height: unset;
    overflow: visible;
    padding-bottom: 64px;
  }

  .private-body main {
    overflow: visible;
    min-height: unset;
    padding: var(--spacing-md);
  }

  .navbar-nav {
    display: flex;
    padding: var(--button-vertical-padding, 6px) var(--button-horizontal-padding, 12px);
    align-items: stretch;
    gap: 12px;

    .dropdown-menu .dropdown-submenu {
      > .dropdown-item.dropdown-toggle {
        &::after {
          transition: transform 0.2s ease-in-out;
          transform: rotate(0deg);
        }

        &[aria-expanded="true"]::after {
          transform: rotate(90deg);
        }
      }

      > .dropdown-menu {
        position: static;
        float: none;
        top: auto;
        left: auto;
        margin-top: var(--spacing-2xs, 4px);
        margin-left: var(--spacing-sm, 12px);
        padding-left: var(--spacing-xs, 8px);
        border-left: 2px solid var(--border-primary-default, #D3135A);
        box-shadow: none;
      }
    }
  }
}

.user-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--background-info-light, #DFF7FF);
  color: var(--text-primary-default, #D3135A);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: light;
  font-size: 1.2rem;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: background 0.2s;
}

.user-circle:hover {
  background: var(--background-info-light-hover, #C5E9FF);
}

.btn-notificaciones-nav {
  line-height: 1;
  opacity: 0.95;
}

.btn-notificaciones-nav:hover,
.btn-notificaciones-nav:focus {
  color: var(--text-primary-default, #d3135a) !important;
  transition: all 0.2s ease-in-out;
  opacity: 1;
}

.notificaciones-badge {
  font-size: 0.65rem;
  min-width: 1.1rem;
  padding: 0.2em 0.35em;
}
</style>
